import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button } from '../Button/Button';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { decamelizeKeys } from 'humps';

export const SmsMessageModal = ({ order, onModalClose, isOpen }) => {
  const [loading, setLoading] = useState();

  const formik = useFormik({
    initialValues: {
      message: '',
    },
    validationSchema: Yup.object({
      message: Yup.string()
        .min(1, __('routes.modals.sms_modal.invalid_message'))
        .required(__('routes.modals.sms_modal.required_message')),
    }),

    onSubmit: async (values, formik) => {
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content');

      try {
        setLoading(true);

        await fetch(`/admin/orders/${order.id}/send-sms`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
          },
          body: JSON.stringify(decamelizeKeys(values)),
        });

        formik.resetForm();
        setLoading(false);
        toastr.success(__('orders.modal.send_sms.message_success'));
        onModalClose();
      } catch (error) {
        setLoading(false);
        toastr.error(__('orders.modal.send_sms.message_error'));
      }
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onModalClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      className="max-90-vh"
      contentClassName="max-90-vh"
    >
      <ModalHeader toggle={handleClose}>{__('orders.modal.send_sms.title')}</ModalHeader>

      <ModalBody className="overflow-scroll">
        <form id="smsForm" onSubmit={formik.handleSubmit} noValidate>
          <label htmlFor="message" className="form-label">
            {__('orders.modal.send_sms.message')}
          </label>

          <textarea
            className={
              'form-control' +
              (formik.touched.message && formik.errors.message ? ' is-invalid' : '')
            }
            id="message"
            name="message"
            onChange={formik.handleChange}
            value={formik.values.message}
          />

          {formik.touched.message && formik.errors.message && (
            <div className="invalid-feedback d-block">
              {formik.errors.message}
            </div>
          )}
        </form>
      </ModalBody>

      <ModalFooter>
        <div className="d-flex w-100 justify-content-between">
          <div>
            <Button
              className="btn-secondary mr-1"
              onClick={handleClose}
            >
              {__('app.back')}
            </Button>

            <Button
              type="submit"
              className="btn-primary"
              onClick={formik.submitForm}
              disabled={loading || !formik.isValid}
            >
              {__('app.send')}
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};
